import React, {Component} from 'react'
import Helmet from "react-helmet";
import Logo from "../../assets/images/mobile-logo.png";
import {Icon, Row, Col, Divider, Spin, message, Modal, Button,Radio} from "antd";
import {readToken,checkWxSub,handleWxCode} from "../../utills/wechatUtils"
import ajax from "../../api/ajax";
import {baseUrl} from "../../api";
import noCom from "./images/no-company.png";
class SubscribeBoxList extends Component {
    state={
        loading: false,
        orders:[],
        orders_all:[],
        orders_on_way:[],
        visible:false,
        id:"",
        value:"",
        choseValue:1,
    }
    onChange=(e)=>{
        this.setState({
            choseValue: e.target.value,
        },()=>{
            if(this.state.choseValue===1){
                this.setState({
                    orders:this.state.orders_all,
                })
            }else{
                this.setState({
                    orders:this.state.orders_on_way,
                })
            }
        });
    }
    doUnsub=(id)=>{
        let wxToken = readToken();
        let token = wxToken.accessToken;
        let openId = wxToken.openid;
        let data = {};
        if(Number.isInteger(id)) {
            data = {
                openid:openId,
                token: token,
                id:id,
            }
            let result = ajax(baseUrl + "/d/public/subscribe", data, "DELETE");
            result.then((resp) => {
                if (resp && resp.code > 201) {
                    message.error(resp.message)
                } else {
                    message.info("取消成功")
                }
            }).finally(() => {
                this.setState({
                    loading:false,
                })
                this.getSubList(wxToken)
            })
        }
    }
    getSubList=(wxToken)=>{
        let token = wxToken.accessToken;
        let openId = wxToken.openid;
        let params = {openid:openId,token:token,type:"box"}
        this.setState({
            loading:true
        })
        let result = ajax(baseUrl+"/d/public/subscribes",params);
        result.then((resp)=>{
            if(resp&&resp.code===400){
                //this.wxReset();
            }else{
                let subInfo = resp.data
                let orders_on_way = []
                for(let i=0;i<subInfo.length;i++){
                    if(subInfo[i].child) {
                        subInfo[i] = Object.assign(subInfo[i],subInfo[i].child[0])
                    }
                    if(subInfo[i].logisticsStatus !=="destination"){
                        orders_on_way.push(subInfo[i])
                    }
                }
                subInfo.sort((a,b)=>{
                    let s = a.logisticsStatus ==="destination"?1:0
                    let t = b.logisticsStatus ==="destination"?1:0
                    return s-t
                })
                if(this.state.choseValue===1){
                    this.setState({
                        orders:subInfo,
                    })
                }else{
                    this.setState({
                        orders:orders_on_way,
                    })
                }
                this.setState({
                    orders_all:subInfo,
                    orders_on_way:orders_on_way,
                })
            }
        }).catch(()=>{
            this.setState({
                orders:[],
                orders_all:[],
                orders_on_way:[],
            })
        }).finally(()=>{
            this.setState({
                loading:false,
                visible:false,
            })
        })
    }
    showConfirm =(info) => {
        this.setState({
            value:info.boxNo,
            id:info.id,
        },()=>{
            this.setState({
                visible:true,
            })
        })
    }
    componentDidMount() {
        handleWxCode(this.props).then((ret)=>{
            checkWxSub()
            this.getSubList(ret)
        }).catch((e)=>{
            //console.error(e)
        })
    }

    render() {
        return (
            <div className='mobile-upload'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                    title="呜呜网铁"
                />
                <div className='mobile-upload-header'>
                    <img src={Logo} alt="Logo"/>
                </div>
                <div className='subscribe'>
                    <div className='subscribe-title'>
                        已关注的集装箱
                        <div className='subscribe-add' onClick={()=>{this.props.history.push("/sub/box/search/")}}>
                            <Icon type="plus" />
                            &nbsp;添加关注
                        </div>
                    </div>
                    <Spin size="large" spinning={this.state.loading}>
                        {this.state.orders && this.state.orders.length>0?(
                            <div>
                        {this.state.orders.map((order,key)=>(
                            <div className={order.logisticsStatus ==="destination"?"subscribe-box done":"subscribe-box"} key={key}>
                                <Row>
                                    <Col span={3}>
                                        <div className="subscribe-box-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20.262" height="11.671" viewBox="0 0 20.262 11.671">
                                                <g id="集装箱" transform="translate(-44.523 -121.487)">
                                                    <path id="路径_293" data-name="路径 293" d="M221.484,245.534a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,1,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,1,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.35,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Z" transform="translate(-173.841 -114.213)"/>
                                                    <path id="路径_294" data-name="路径 294" d="M63.7,121.487H45.6a1.081,1.081,0,0,0-1.081,1.081v9.51a1.081,1.081,0,0,0,1.081,1.081H63.7a1.081,1.081,0,0,0,1.081-1.081v-9.51A1.081,1.081,0,0,0,63.7,121.487Zm.005,10.6H45.6v-9.531H63.71v9.531Z" transform="translate(0)" />
                                                </g>
                                            </svg>
                                        </div>
                                    </Col>
                                    <Col span={21}>
                                        箱号：{order.boxNo}
                                        {order.logisticsStatus ==="destination"?
                                            <div className="subscribe-box-row-right">
                                                已完成
                                            </div>
                                            :
                                            <div className="subscribe-box-row-right" onClick={this.showConfirm.bind(this,order)}>
                                                取消关注
                                            </div>
                                        }

                                    </Col>
                                    <Divider style={{margin:"10px 0",display:"inline-block"}}/>
                                </Row>
                                <Row>
                                    <Col span={3}>
                                        <div className="subscribe-box-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.802" viewBox="0 0 16.5 16.802">
                                                <path id="铁路_1_" data-name="铁路 (1)" d="M88.335,80.757a.448.448,0,0,1-.193.045.432.432,0,0,1-.388-.236l-.315-.617H73.211l-.315.617a.437.437,0,0,1-.388.236.441.441,0,0,1-.193-.045.424.424,0,0,1-.2-.572l1.736-3.409a.439.439,0,0,1,.583-.191.424.424,0,0,1,.2.572l-.12.234H86.135l-.12-.234a.422.422,0,0,1,.2-.572.44.44,0,0,1,.583.191l1.736,3.409a.426.426,0,0,1-.2.572ZM86.57,78.244H74.08l-.435.853H87Zm-.908-1.652h-.5l.011.011H83.819l-.009-.011H77.219l-.009.011H75.854l.011-.011h-.591c-.24,0-.666-.364-.666-.6l.289-8.879a.878.878,0,0,1,.653-.78,19.182,19.182,0,0,1,3.19-.939,1.8,1.8,0,0,1,3.508.006,18.976,18.976,0,0,1,3.169.936.885.885,0,0,1,.653.78l.219,8.877A.8.8,0,0,1,85.663,76.592ZM83.771,75.6A1.054,1.054,0,1,0,82.7,74.544,1.061,1.061,0,0,0,83.771,75.6Zm-6.567,0a1.054,1.054,0,1,0-1.067-1.054A1.061,1.061,0,0,0,77.2,75.6Zm3.289-10.574a.752.752,0,1,0,.761.752A.758.758,0,0,0,80.493,65.024Zm4.446,2.758a.649.649,0,0,0-.653-.645,14.773,14.773,0,0,0-2.228-.5,1.793,1.793,0,0,1-3.128,0,14.7,14.7,0,0,0-2.243.5.649.649,0,0,0-.653.645l-.311,4.185a.432.432,0,0,0,.435.429h8.647a.433.433,0,0,0,.435-.429Z" transform="translate(-72.075 -64)"/>
                                            </svg>
                                        </div>
                                    </Col>
                                    <Col span={21}>
                                        {order.originCountry}·{order.originCity}
                                        &nbsp;
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.652" height="6.063" viewBox="0 0 14.652 6.063">
                                            <g id="长箭头" transform="translate(-14.44 -309.495)">
                                                <path id="路径_295" data-name="路径 295" d="M14.44,490.254H23.9v.876H14.44Z" transform="translate(0 -178.138)" fill="#999"/>
                                                <path id="路径_296" data-name="路径 296" d="M673.811,309.495l5.093,2.991-5.093,3.072Z" transform="translate(-649.812)" fill="#999"/>
                                            </g>
                                        </svg>
                                        &nbsp;
                                        {order.destinationCountry}·{order.destinationCity}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={3}>
                                        <div className="subscribe-box-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                                <path id="时间" d="M28.035,22.578l-.49.78,2.791,1.751.49-.772-2.791-1.76Zm.428-3.25h-.918v4.03h.918ZM28,16.384a6.5,6.5,0,1,0,6.5,6.5A6.5,6.5,0,0,0,28,16.384Zm0,.918a5.582,5.582,0,1,1-5.582,5.582A5.584,5.584,0,0,1,28,17.3Z" transform="translate(-21.504 -16.384)"/>
                                            </svg>
                                        </div>
                                    </Col>
                                    <Col span={21}>
                                        出发时间：{order.deliveryDt}
                                    </Col>
                                </Row>
                            </div>
                        ))}</div>)
                            :
                            <div className='subscribe-box-info'>
                                <img src={noCom}/>
                                <div style={{fontSize:"1rem",padding:20}}>暂无关注信息</div>
                                <div style={{fontSize:"0.8rem",padding:8,color:"#1592D5",border:"1px solid",width:"fit-content",margin:"auto"}} onClick={()=>{this.props.history.push("/sub/box/search/")}}>前往关注集装箱动态</div>
                            </div>
                        }
                    </Spin>
                </div>
                <Modal className={"sub_modal"}
                       visible={this.state.visible}
                       onOk={()=>{}}
                       onCancel={()=>{this.setState({visible: false})}}
                       footer={[<Button.Group style={{width:"100%"}} key={"btgroup001"}>
                           <Button type='primary' style={{width:"50%"}} loading={this.state.loading} onClick={()=>{this.setState({loading:true});this.doUnsub(this.state.id)}}>确定</Button>
                           <Button style={{width:"50%"}} onClick={()=>{this.setState({visible: false})}}>取消</Button>
                       </Button.Group>]}
                >
                    <div className='subscribe-info-box'>
                        <div>您将取消对</div>
                        <div style={{color:"#1592D5"}}>箱号：{this.state.value}</div>
                        <div>的关注吗？</div>
                    </div>
                </Modal>
                <div className='subscribe-footer' style={{backgroundColor:"#EDEDED"}}>
                    <Radio.Group onChange={this.onChange} value={this.state.choseValue} buttonStyle={{backgroundColor:"#FEB607"}}>
                        <Radio value={1}>全部</Radio>
                        <Radio value={2}>只显示在途集装箱</Radio>
                    </Radio.Group>
                </div>
            </div>
        )
    }
}
export default SubscribeBoxList